import React, { createContext, useContext } from 'react';

export const NTATestContext = createContext();

export const useNTATest = () => {
    return useContext(NTATestContext);
};